import * as React from 'react';
import { ComponentLayoutMap } from './component-layout-map';
import { ComponentLayoutType } from '../component-layout';

/**
 * Looks at the code-split series promo component and renders the desired ui component based on the name.
 */
export const ComponentLayout = (props: ComponentLayoutType<any>) => { 
  const componentName = props?.moduleName ? props?.moduleName : 'common-module';
  const component = ComponentLayoutMap(componentName);

  if (!component) {
    return null;
  }

  return React.createElement(component as any, props);
};
